/*
 * Jira Ticket:
 * Created Date: Wed, 19th Feb 2020, 16:43:25 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import polyglotI18nProvider from 'ra-i18n-polyglot';
import raEnglishMessages from 'ra-language-english';
// import {
//   raTreeLanguageEnglish
// } from "@react-admin/ra-tree";

export const cmsTitle = 'TowerSure - Console - ';

const englishMessages = {
  ...raEnglishMessages,
  // use the following structure for resource translations
  resources: {
    General: {
      cmsTitle,
      help: 'Help',
    },
    Dashboard: {
      title: `${cmsTitle}Dashboard`,
      fields: {
        assembledTowers: 'Assembled Towers',
        awaitingApproval: 'Inspections Awaiting Approval',
        expiredInspections: 'Expired Inspections',
        rejectedInspections: 'Rejected Inspections',
        projects: 'Projects',
        sites: 'Sites',
      },
    },
    Organisation: {
      name: 'Organisation |||| Organisations',
      emptyStateTitle: `No organisations yet.`,
      emptyStateSubtitle: `Create a new organisation.`,
      fields: {
        addressOne: 'Address Line 1',
        addressTwo: 'Address Line 2',
        checkList: 'Checklist Required',
        city: 'City or Town',
        country: 'Country',
        createTitle: `${cmsTitle}Create Organisation`,
        editTitle: 'Organisation Detail',
        numberOfProjects: 'Projects',
        numberOfSites: 'Sites',
        numberOfUsers: 'Users',
        organisation: 'Organisation',
        orgName: 'Organisation Name',
        pendingInvitesCancel: 'No, thanks',
        pendingInvitesConfirm: 'Go to Invites',
        pendingInvitesMessage:
          'You have pending organisation invites. Would you like to view them?',
        pendingInvitesTitle: 'Pending Invites',
        pocEmail: 'Point of Contact Email',
        pocName: 'Point of Contact Name',
        pocNum: 'Point of Contact Number',
        pocPosition: 'Point of Contact Position',
        postcode: 'Postcode/Zipcode',
        projectAccess: 'Project Access',
        tab1: 'Overview',
        tab2: 'Projects',
        tab3: 'Sites',
        tab4: 'Users',
        tab5: 'Contracts',
        tab6: 'Subcontractors',
        tab7: 'Planned Towers',
        tab8: 'Subscription',
      },
    },
    TowerType: {
      name: 'Tower Type |||| Tower Types',
      fields: {
        questions: 'Questions',
        lastUpdated: 'Last Updated',
        status: 'Status',
        towerDetail: 'Tower Types - Tower Details',
        qualifications: 'Required Qualifications',
        checkList: 'Checklist Questions',
        question: 'Question',
        media: 'Media Upload',
        qualificationHelperText:
          'Comma-separated list of required Qualification IDs',
      },
    },
    Template: {
      name: 'Template |||| Templates',
      fields: {
        name: 'Template',
        editTitle: '%{templateName} Template',
        variables: 'Template Variables',
        subject: 'Subject',
      },
    },
    Project: {
      emptyStateNoOrgTitle: `No projects yet.`,
      emptyStateTitle: `No projects yet.`,
      emptyStateNoOrgSubtitle: `In order to create a project, please make an organisation first.`,
      emptyStateSubtitle: `Create a new project.`,
      name: 'Project |||| Projects',
      noOrganisations: 'All Projects',
      fields: {
        project: 'Project',
        allowSites: 'App users may add sites',
        allowTowerImages: 'Share images with Check-a-Tower',
        numberOfSites: 'Sites',
        numberOfUsers: 'Users',
        numberOfTowers: 'Towers',
        numberOfBuilders: 'App Users',
        numberOfApprovers: 'Approvers',
        checklistType: 'Checklist Type',
        organisation: 'Organisation',
      },
      checklistTypes: {
        inAppAutoApprove: 'In app checklist (automatically approve)',
        inAppCmsApprove: 'In app checklist (approve in console)',
        inCms: 'Checklist in console',
      },
    },
    Site: {
      name: 'Site |||| Sites',
      emptyStateNoOrgTitle: `No sites yet.`,
      emptyStateTitle: `No sites yet.`,
      emptyStateNoOrgSubtitle: `In order to create a site, please make an organisation first.`,
      emptyStateSubtitle: `Create a new site.`,
      noOrganisations: 'All Sites',
      fields: {
        name: 'Site',
        project: 'Project',
        numberOfTowers: 'Towers',
        numberOfUsers: 'Users',
        numberOfBuilders: 'App Users',
        numberOfApprovers: 'Approvers',
        latitude: 'Latitude',
        longitude: 'Longitude',
        postCode: 'Postcode and/or place name',
        location: 'Location',
        siteName: 'Site Name',
        organisation: 'Organisation',
      },
    },
    User: {
      name: 'User |||| Users',
      noOrganisations: 'All Users',
      fields: {
        accessTo: 'Has access to',
        assignedProjects: 'Assigned Projects',
        certNum: 'PASMA Certificate Number',
        email: 'Email',
        id: 'User ID',
        emailAddress: 'Email Address',
        familyName: 'Last Name',
        givenName: 'First Name',
        UserStatus: 'Status',
        inviteCSV:
          'Drop the invite CSV below. If you require a template, please utilise the download CSV button.',
        inviteesEmail: 'Invitees email(s) (comma separated)',
        inviteMethod: 'Invite Method',
        inviteOnBehalf: 'Who are you inviting on behalf of?',
        inviteUser: 'Invite User',
        inviteUserConfirmModalContent:
          '%{noEmails} email(s) found: %{listEmails}',
        inviteUserConfirmModalTitle: 'Invite users to %{organisationName}?',
        inviteUserErrorModalTitle: 'Error in CSV',
        isAdmin: 'PASMA Admin',
        organisation: 'Organisation',
        organisations: 'Organisations',
        position: 'Position',
        project: 'Project',
        projects: 'Projects',
        role: 'Role',
        roleLevel: 'What is their role level?',
        status: 'PASMA Admin?',
        tab1: 'User Details',
        tab2: 'User Roles',
        tab3: 'Organisation Invites',
        uploadInfo:
          'To invite multiple users, create a CSV file with a single column containing email addresses only. Drop the file in the box below or click on the box to select the file on your computer.',
        userDetail: 'User Detail',
        whatAccess: 'What will the user have access to?',
        whichProjects: 'Which projects are you granting access to?',
      },
    },
    Employment: {
      name: 'Employment |||| Employments',
      fields: {
        title: `${cmsTitle}User - Roles Detail`,
        email: 'Email',
        invitingOrg: 'Inviting Organisation',
        project: 'Project',
        status: 'Status',
        organisation: 'Organisation',
        contractingOrg: 'Contractor',
        role: 'Organisaton Role',
        accessTo: 'Has access to',
        projects: 'Projects',
        updateInviteModalTitle: '%{action} Employment Invitation',
        updateInviteModalContent:
          'Are you sure you want to %{action} your invitation with %{invitingOrgName}?',
        deleteEmploymentModalTitle: 'Remove User',
        deleteEmploymentModalContent:
          'Are you sure you want to remove this user (%{email}) from %{orgName}?',
        pendingStatus: ' (Invited)',
        rejectedStatus: ' (Rejected)',
        acceptedStatus: '',
      },
    },
    Subcontractor: {
      name: 'Subcontractor |||| Subcontractors',
      noOrganisations: 'All Subcontractors',
      emptyStateTitle: `No subcontractors yet.`,
      emptyStateSubtitle: `Click to invite a subcontractor.`,
      emptyStateNoOrgTitle: `No subcontractors yet.`,
      emptyStateNoOrgSubtitle: `You need to create an organisation before you create a subcontractor.`,
      fields: {
        invitedOrg: 'Invited Organisation',
        invitingOrg: 'Inviting Organisation',
        assignedProjects: 'Assigned Projects',
        project: 'Project',
        projects: 'Projects',
        workingFor: 'Working For',
        numberOfUsers: 'Users',
        status: 'Invite Status',
        inviteSubcontractor: 'Invite Subcontractor',
        toWorkFor: 'Inviting on behalf of',
        inviteOrg: 'Who are you inviting?',
        toProjects: 'Which projects?',
        updateContractModalTitle: '%{action} Contract',
        updateContractModalContent:
          'Are you sure you want to %{action} your invitation with %{invitingOrgName}?',
        allowSubcontractor: 'Allow Access for Subcontractors',
        maxRole: 'What is the maximum role level?',
      },
      inviteSubcontractor: 'Click to invite a subcontractor',
    },
    Contract: {
      noOrganisations: 'All Contracts',
      emptyStateTitle: 'No contracts yet.',
      emptyStateSubtitle:
        'To be able to be invited as a contractor you must create an organisation first.',
      noContractsFound: 'No contracts found.',
    },
    Inspection: {
      name: 'Inspection |||| Inspections',
      noOrganisations: 'All Inspections',
      fields: {
        towerId: 'Tower ID',
        organisation: 'Organisation',
        project: 'Project',
        site: 'Site',
        inspectionNo: 'Inspection No',
        inspectionStatus: 'Inspection Status',
        date: 'Date',
        towerStatus: 'Tower Status',
        dateFrom: 'Date From',
        dateTo: 'Date To',
        inspectionTowerDetails: `${cmsTitle}Tower Details`,
        tab1: 'Tower Details',
        tab2: 'Inspection Detail',
        builderName: 'Assembled By',
        recordTag: 'Inspection Record Label',
        latitude: 'Latitude',
        towerType: 'Tower Type',
        qualificationStatus: "Assembler's Qualification Status",
        platformHeight: 'Platform Height',
        environment: 'Environment',
        longitude: 'Longitude',
        notes: ' Notes',
        certNum: "Assembler's PASMA Cert Number",
        inspectorName: 'Inspector Name',
        approverName: 'Approver Name',
        automaticallyApproved: 'Automatically approved',
        dateTime: 'Inspection Date and Time',
        inspectionComments: 'Inspection Comments',
        approverComments: 'Approval Comments',
        images: 'Inspection Images',
        expired: 'Inspection Expired',
        updateInspectionModalTitle: 'Update Tower Inspection',
        updateInspectionModalContent:
          'Are you sure you want to submit with status %{action}?',
      },
    },
    Checklist: {
      name: ' Checklist',
      approveChecklist: 'Approve checklist',
    },
    Tower: {
      name: 'Tower |||| Planned Towers',
      noOrganisations: 'All Planned Towers',
      fields: {
        towerDetail: 'Planned Towers - Tower Details',
        create: 'Planned Towers - Create Tower',
        id: 'Tower ID',
        organisation: 'Organisation',
        project: 'Project',
        site: 'Site',
        date: 'Date Created',
        status: 'Approval Status',
        type: 'Tower Type',
        height: 'Platform Height',
        notes: 'Notes',
        mediaUpload: 'Media Upload',
        createdAfter: 'Created From',
        createdBefore: 'Created To',
      },
    },
    Region: {
      name: 'Region |||| Regions',
      fields: {
        regionName: 'Region Name',
        noCountries: 'Number of Countries',
        countries: 'Countries',
        locales: 'Locales',
        titles: {
          edit: 'Edit Region',
        },
      },
    },
    Advert: {
      name: 'Advertisement |||| Advertisements',
      fields: {
        adName: 'Ad Name',
        advertiserName: 'Advertiser Name',
        liveDate: 'Live Date',
        endDate: 'End Date',
        regions: 'Regions',
        regionsRequired: 'Regions *',
        region: 'Region',
        status: 'Status',
        titles: {
          edit: {
            tab1: 'Advert Details',
            tab2: 'Analytics',
          },
        },
        url: 'Web URL',
        duration: 'Ad Length',
        freqWeight: 'Chance of Appearance',
        media: 'Advert Image (2:3)',
        currentImg: 'Current Advert Image',
        updateImg: 'Update Advert Image (2:3)',
        impressions: 'Impressions',
        engagements: 'Engagements',
      },
    },
    Configuration: {
      name: 'Configuration',
      title: `${cmsTitle}Configuration`,
      fields: {
        advertFrequency: 'Advert Frequency',
        defaultAdvertLength: 'Default Advert Length',
        reinspectionFrequency: 'Reinspection Frequency',
        confirmTowerAssembledCorrectlyText:
          'In App Text: Tower assembled correctly checkmark text',
        upgradeAccountInspectionTagPrompt:
          'In App Text: Upgrade account to acquire inspection label capability',
        invalidCertificateText: 'In App Text: Invalid certificate modal text',
        invalidCertificateAgreePrompt:
          'In App Text: Invalid certificate modal agree prompt',
        noTowersFoundText:
          'In App Text: No towers found upon entering value into search field',
        noInputTowersSearchText: 'In App Text: No input inside search field',
        helpUrlAdvert: 'Contextual Help Link: Adverts',
        helpUrlInspection: 'Contextual Help Link: Inspection',
        helpUrlOrganisation: 'Contextual Help Link: Organisation',
        helpUrlProject: 'Contextual Help Link: Project',
        helpUrlRegion: 'Contextual Help Link: Region',
        helpUrlSite: 'Contextual Help Link: Site',
        helpUrlSubscription: 'Contextual Help Link: Subscription Tier',
        helpUrlTowerType: 'Contextual Help Link: Tower Type',
        helpUrlUser: 'Contextual Help Link: User',
        helpUrlTemplate: 'Contextual Help Link: Template',
      },
    },
    ConfigurationItem: {
      name: 'Configuration',
      title: `Configuration`,
      fields: {
        key: 'Configuration Item Name',
        value: 'Content',
      },
    },
    SubscriptionTier: {
      name: 'Tier Management',
      fields: {
        createTitle: 'Create Subscription Tier',
        name: 'Tier Name',
        monthlyCost: 'Monthly Cost',
        annualCost: 'Annual Cost',
        monthlySubscribers: 'Monthly Subscribers',
        freeSubscribers: 'Free Subscribers',
        annualSubscribers: 'Annual Subscribers',
        freeTrailLength: 'Free Trial Length (Days)',
        maxEmployee: 'Maximum Employees',
        maxSubcontractor: 'Maximum Subcontractors',
        maxProject: 'Maximum Projects',
        isCustomTier: 'Custom Tier',
        isFreeTier: 'Free Tier',
        customOrganisations: 'Custom Organisations',
        monthlySubscription: 'Monthly Subscription',
        annualSubscription: 'Annual Subscription',
        freeSubscription: 'Free Subscription',
        changeSubscription: 'Change Subscription',
        upToMaxEmployee: 'Up to %{maxNo} employees',
        upToMaxSubcontractor: 'Up to %{maxNo} subcontractors',
        upToMaxProject: 'Up to %{maxNo} projects',
        confirmationModalSubtitleInc:
          'Included in your selected subscription package: ',
        confirmationModalSubtitleNotInc:
          'Not Included in your selected subscription package: ',
        confirmationContent1: 'By clicking "Confirm and Pay" you agree to our ',
        confirmationContent1Free: 'By clicking "Confirm" you agree to our ',
        confirmationContent2:
          ', and are confirming your subscription to the above services. All previous subscriptions and free trials will be cancelled.\b Your %{freeTrialLength} day free trial will be activated immediately.\b After %{freeTrialLength} days you will be charged ',
        confirmationContent2Free:
          ', and are confirming your subscription to the above services. All previous subscriptions and free trials will be cancelled.\b',
        confirmationContent2NoFreeTrial:
          ', and are confirming your subscription to the above services. All previous subscriptions and free trials will be cancelled.\b You will be charged ',
        terms: 'Terms',
        perMonth: ' per month.',
        perYear: ' per year.',
        confirmAndPay: 'Confirm and Pay',
        confirm: 'Confirm',
        redirectionModalTitle: 'Please wait',
        redirectionModalContent1: 'Please wait to be redirected to Paypal.',
        redirectionModalContent2:
          'If you are not redirected after 5 seconds, please click the link below. Note that the use of ad blockers will prevent the window from opening.',
        redirectionModalContentLinkText: 'Take me to PayPal',
        cancelSubscriptionModalTitle: 'Cancel Subscription',
        cancelSubcriptionModalContent1:
          'Are you sure you want to cancel your current subscription?',
        cancelSubcriptionModalContent2:
          'By clicking "Confirm" your current subscription and any active free trials will be cancelled and you will return to the initial free tier.',
        closeCancelSubscription: 'Close',
        informationModalTitle: 'Notice',
        informationModalContent1:
          'Please note that it can take up to 10 minutes for subscription changes to take effect after payment confirmation.',
        informationModalContent2:
          'If you do not see the correct subscription tier, please contact your administrator, or ',
        informationModalContent3: 'contact us.',
      },
    },
  },
  authentication: {
    login: {
      submit: 'Login',
      register: 'Register',
      username: 'Email',
      password: 'Password',
      forgotPassword: 'Forgot Password?',
    },
    register: {
      givenName: 'First Name *',
      familyName: 'Last Name *',
      email: 'Email *',
      password: 'Password *',
      certificate: 'PASMA Certificate Number',
      submit: 'Register',
      position: 'Position *',
    },
    termsAndConditions: {
      title: 'Terms and Conditions',
      submit: 'Accept Terms and Conditions',
      loading: 'Fetching terms and conditions, just a moment please',
    },
    forgotPassword: {
      email: 'Email',
      submit: 'Send Reset Code',
      cardContent:
        'Please enter your email address above.\n You will receive an email with a code that you can redeem to reset your password.',
    },
    changePassword: {
      verificationCode: 'Verification Code',
      newPassword: 'New Password',
      cardContent:
        'We just sent you an email with a verification code attached.\nPlease enter this here and type your new password below to reset.',
      submit: 'Reset Password',
    },
    forceChangePassword: {
      cardContent: 'Please change your password to continue signing in.',
      submit: 'Change Password',
    },
  },
  error: {
    auth: {
      invalidCredentials:
        'The email and password combination is not recognised. Please re-enter and try again.',
      passwdChangeUnsuccessful: 'Password change unsuccessful',
      resetPwdFailure: 'Unable to reset password: %{errMsg}',
      errorInReg: 'There was an error during registration',
      accountAlreadyExists: 'An account with the given email already exists',
      unableToGetTCs: 'Unable to retrieve registration terms and conditions',
      unableToVerifyCert: 'Unable to verify PASMA certificate details',
      unableToLogin: 'Unable to login. Please try again',
    },
    permissions: {
      title: 'Access Denied',
      header: 'You do not have the required permissions to view this page',
      subtitle: 'Contact your administrator for necessary permissions',
    },
    create: {
      noOrgId: 'Unable to access create form, no organisation id held in state',
    },
    maps: {
      addressDoesNotExist: 'No location result found for "%{address}"',
      geocoderFailure: 'Geocoder failed due to: %{status}',
      emptySearch: 'Please provide a postcode or place name to search',
    },
    inviteUser: {
      noEmptyLine:
        'Please ensure there are no new (empty) lines at the end of the file',
      invalidRecord: 'Invalid record "%{record}" found at line %{lineNumber}',
      invalidEmail:
        'Invalid email format "%{data}" found at line %{lineNumber}',
      maxEmailsReached:
        'Maximum of 50 emails per request exceeded (%{emailListLength} entries found)',
    },
    generic: 'Oops! There was a problem processing your request',
    termsAndConditionsEdit: {
      unableToGetTCs:
        'Unable to retrieve terms and conditions copy, please refresh to try again',
    },
    configEdit: {
      unableToGetConfig:
        'Unable to retrieve system configuration, please refresh to try again',
    },
    dashboard: {
      unableToGetStats:
        'Unable to retrieve Dashboard statistics, please refresh to try again',
    },
    user: {
      unableToGetEmployment: 'Unable to retrieve user employment data',
    },
    organisation: {
      unableToGetInformation: 'Unable to fetch organisation information',
    },
    fileUpload: {
      fileTooBig: 'File %{filename} is larger than %{maxSize}',
      fileWrongType:
        'File %{filename} is not one of accepted types %{allowedFileTypes}',
      unknownRejection: 'Unable to upload file %{filename}',
    },
    imageNotFound: 'Image Not Found',
    imagesNotFound: 'No Images Found',
    noPdf: 'No file returned from server',
    userNotLoggedIn: 'You need to login to access that page',
    region: {
      errorGettingData: 'Unable to retrieve %{dataType} list',
    },
    advert: {
      wrongAspectRatio: 'Advert image must be 2:3',
      unableToGetConfig:
        'Unable to retrieve system configuration for default advert duration',
    },
    subscriptionTier: {
      unableToGetCapabilities: 'Unable to fetch permissions list',
    },
  },
  notification: {
    auth: {
      passwdResetSent: 'Reset password request sent',
      passwdChanged: 'Password changed successfully',
    },
    loading: {
      map: 'The map is loading, just a moment please',
    },
    employment: {
      revokeSuccess: 'Invitation revoked successfully',
    },
    contract: {
      updateSuccess: 'Invitation updated successfully',
      updateFailure: 'Unable to update invitation, please try again',
    },
    termsAndConditions: {
      updateSuccess: 'Terms and Conditions updated successfully',
    },
    config: {
      updateSuccess: 'Configuration updated successfully',
      loading: 'Fetching system configuration, just a moment please',
    },
    subscriptionTiersNotFound: 'No subscription data available',
    updateSubscriptionSuccess: 'Your subscription was modified successfully',
  },
  validation: {
    passwdSpecial: 'Password must contain a special character',
    passwdNumber: 'Password must contain a number',
    passwdLower: 'Password must contain a lowercase character',
    passwdUpper: 'Password must contain an uppercase character',
    passwdMinLen: 'Password must be at least 12 characters',
    passwdMaxLen: 'Password must be no more than 99 characters',
    invalidEmail: 'Invalid email format',
    invalidPhone: 'Not a valid phone number of the form +17895551234',
    invalidUrl: 'Invalid URL format',
    notAnInt: 'Not an integer',
    positivieNonZeroInt: 'Please enter an integer greater than 0',
    positivieInt: 'Please enter a positive integer',
    cappedAt20: 'Please enter a numer smaller than or equal to 20',
    beforeLive: 'Cannot be before Live Date',
    afterEnd: 'Cannot be after End Date',
    notACurrency: 'Please enter a valid currency e.g. 123.45',
    qualificationIdsIncorrectFormat:
      'Must be a comma separated list of ids e.g. 1,2,3',
  },
  actions: {
    search: 'Search',
    inviteUsers: 'Invite Users',
    invite: 'Invite',
    downloadTemplate: 'Template CSV',
    accept: 'Accept',
    reject: 'Reject',
    revoke: 'Revoke',
    removeUser: 'Remove User',
    export: 'Export',
    approve: 'Approve',
    reinspect: 'Reinspect',
    doNotUse: 'Do Not Use',
    downloadPDF: 'Download PDF',
    exportInspectionCSV: 'Export CSV',
    clickToEnlarge: 'Click to Enlarge',
    cancelSubscription: 'Cancel Subscription',
    create: 'Create',
    createOrganisation: 'Create Organisation',
    createProject: 'Create Project',
    createSite: 'Create Site',
    createSubcontractor: 'Create Subcontractor',
    inviteSubcontractor: 'Invite Subcontractor',
  },
};

const messages = {
  // ...raTreeLanguageEnglish
  en: { ...englishMessages },
};
const i18nProvider = polyglotI18nProvider(locale => messages[locale], 'en', {
  allowMissing: true,
});

// export { englishMessages };

export default i18nProvider;
